import React, { useState } from "react"
import { useI18next } from "@zestia/gatsby-plugin-react-i18next"
import { buildRequestBodyForExternalAuth, createSession } from "@/utils/signup"
import { appServerHost } from "@/utils/app-server"
import { gtmTracking } from "@/utils/gtm-tracking"

const OAuthSignupButton = ({
  integrationType,
  buttonText,
  location,
  className = "",
  onClick: _onClick, // Extract and ignore the onClick from props
  ...props
}) => {
  const [isLoading, setIsLoading] = useState(false)
  const { language } = useI18next()

  const handleSignup = async () => {
    if (!integrationType) {
      return
    }

    setIsLoading(true)

    // Simple configuration - only Crunch for now, but easy to extend
    const config = {
      crunch: {
        oauthType: "Crunch",
        plan: "free",
        variation: "crunch",
        planFrequency: "MONTHLY",
      },
      // Future integrations can be added here:
      // xero: { oauthType: "Xero", plan: "growth", variation: "xeromarketplace", planFrequency: "MONTHLY" },
    }

    const integrationConfig = config[integrationType]
    if (!integrationConfig) {
      setIsLoading(false)
      return
    }

    // GTM tracking
    gtmTracking("CTA Click", buttonText, integrationConfig.oauthType)()

    try {
      const requestBody = buildRequestBodyForExternalAuth(
        integrationConfig.oauthType,
        integrationConfig.plan,
        integrationConfig.variation,
        language,
        integrationConfig.planFrequency,
      )

      const data = await createSession(location, requestBody)
      const sessionId = data.signup ? data.signup.id : null

      if (sessionId) {
        window.location = `https://app.${appServerHost(location)}/oauth2/signup/${integrationConfig.oauthType.toLowerCase()}?session_id=${sessionId}`
      } else {
        throw new Error("Unable to process your request")
      }
    } catch (error) {
      setIsLoading(false)
    }
  }

  return (
    <button
      className={`${className} ${isLoading ? "loading" : ""}`}
      disabled={isLoading}
      onClick={handleSignup}
      {...props}
    >
      {isLoading ? "Loading..." : buttonText}
    </button>
  )
}

export default OAuthSignupButton
